import { useMemo } from "react";
import { americanRouletteNumbers, GameIds, MASTS, spinNumbers } from "../../../../../constants/games";
import { getNextBeforeNumbersDataRoulette } from "../../../../../helpers/next-before-numbers-data-roulette";

interface SpinToWinProps {
  gameId: number;
  result: string;
}

const Roulette: React.FC<SpinToWinProps> = ({ gameId, result }) => {
  const { number, mastNumber } = JSON.parse(result);
  const resultData = useMemo((): any => {
    const spinNumbersList = gameId === GameIds.AmericanRoulette ? americanRouletteNumbers : spinNumbers;
    return getNextBeforeNumbersDataRoulette(number, spinNumbersList);
  }, [result, gameId]);

  if (!result) return null;

  return (
    <>
      {gameId === GameIds.VirtualSpinToWinDeluxe ? (
        <div
          className={`nonStopRouletteAndSpinHolderLeft ${MASTS[mastNumber]}`}
        />
      ) : null}

      <div className="nonStopRouletteAndSpinHolderMiddle">
        <div className={`rouletteAndSpinImgHolder leftCard ${resultData.beforeNumberColor}`}>
          <span className="rouletteImgTxt leftTxt">
            {resultData?.beforeNumber}
          </span>
        </div>
        <div className={`rouletteAndSpinImgHolder middleCard ${resultData.winNumberColor} active`}>
          <span className="rouletteImgTxt middleTxt">{number === 37 ? '00': number}</span>
        </div>
        <div className={`rouletteAndSpinImgHolder rightCard ${resultData.nextNumberColor}`}>
          <span className="rouletteImgTxt rightTxt">
            {resultData.nextNumber}
          </span>
        </div>
      </div>
      {gameId === GameIds.VirtualSpinToWin ||
      gameId === GameIds.VirtualSpinToWinDeluxe ||
      gameId === GameIds.VirtualRouletteLightning ? (
        <span className="nonStopRouletteAndSpinHolderRight">
          {resultData.sector}
        </span>
      ) : null}
    </>
  );
};

export default Roulette;
